/** OAuth 客户端标识，与认证服务约定；测试/正式在 .env.development / .env.production 中配置 */
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID || 'hytcebook'
export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET || 'hytcebook.7,f@e'
